<template>
  <v-layout>
    <v-flex v-if="reportsPending">
      <v-flex>
        Getting employee's hours...
        <v-progress-linear indeterminate></v-progress-linear>
      </v-flex>
    </v-flex>
    <v-flex v-else>
      <v-layout column full-width>
        <v-layout row align-center>
          <v-flex class="mr-2">
            <v-autocomplete
              label="Employee"
              :items="selectableEmployees"
              item-text="name"
              item-value="id"
              v-model="employeeID"
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex>
            <v-select
              v-model="timePeriod"
              :items="timePeriodItems"
              item-text="name"
              item-value="param"
              label="Time Period"
            >
            </v-select>
          </v-flex>
          <v-flex>
            <v-btn @click="reGetRecords" color="primary">
              Fetch
            </v-btn>
          </v-flex>
        </v-layout>

        <v-data-table
          :items="report.shifts"
          :headers="headers"
          item-key="worksite_id"
          class="elevation-1"
          :defaultSort="{
            sortBy: '',
            ascending: true,
            rowsPerPage: 100,
          }"
        >
          <template slot="items" slot-scope="{ item }">
            <tr>
              <td>
                {{ item.segment }}
              </td>
              <td>
                {{ item.count }}
              </td>
              <td>
                {{ item.worked_count }}
              </td>
              <td>
                {{ item.hours }}
              </td>
              <td>
                {{ item.absent_count }} <span class="subtle">({{ Math.round((item.absent_count / item.count) * 100) }}%)</span>
              </td>
              <td>
                {{ item.cancelled_count }} <span class="subtle">({{ Math.round((item.cancelled_count / item.count) * 100) }}%)</span>
              </td>
            </tr>
          </template>
        </v-data-table>

      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import {mapState, mapGetters} from 'vuex';
  // import {ExportToCsv} from 'export-to-csv';
  import EmployeeName from '@/components/hr/employee-name.vue'
  import reportApi from '@/api/reports'
  import collectionApi from '@/api/collections'

  export default {
    components: { EmployeeName, },
    computed: {
      ...mapState('userAuth', ['user']),
      //computedOffset: function () {
      //  return this.limit * (this.page - 1)
      //},
      //pageLength: function () {
      //  return Math.ceil(this.queryTotal / this.limit)
      //},
      formattedQuery: function() {
        return {
          employeeID: this.employeeID,
          period: this.timePeriod,
          start_date: null,
          end_date: null,
          //limit: this.limit,
          //offset: this.computedOffset,
          //page: this.page,
        };
      },
    },
    created() {
      this.setUp();
    },
    watch: {
      //'page': {
      //  handler(value) {
      //    if (value != this.$route.query.page) {
      //      this.reGetRecords()
      //    } else {
      //    }
      //  }
      //}
    },
    data: function() {
      return {
        timePeriod: 'quarter',
        timePeriodItems: [
          {
            name: 'Total',
            param: 'total',
          },
          {
            name: 'By Year',
            param: 'year',
          },
          {
            name: 'By Quarter',
            param: 'quarter',
          },
          {
            name: 'By Month',
            param: 'month',
          },
        ],

        limit: 40,
        page: 1,

        reportsPending: true,
        loadingCsv: false,
        report: {},
        employeeID: null,

        selectableEmployees: [],
        //defaultSort: {
        //  sortBy: 'order',
        //  rowsPerPage: -1, //all
        //},
        headers: [
          { text: 'Period', value: 'quarter', sortable: true },
          { text: 'Shifts Assigned', value: 'count', sortable: true },
          { text: 'Shifts Worked', value: 'worked_count', sortable: true },
          { text: 'Hours Worked', value: 'hours', sortable: true },
          { text: 'Absent', value: 'absentees', sortable: true },
          { text: 'Cancelled', value: 'cancelled_count', sortable: true },
        ],
      };
    },

    methods: {
      maybeGetEmployees() {
        if (this.selectableEmployees.length === 0) {
          this.apiCallPending = true
          collectionApi.getEmployees(employees => {
            this.selectableEmployees = employees
            this.apiCallPending = false
          })
        }
      },

      setUp: function() {
        this.maybeGetEmployees()
        this.period = this.$route.query.period || this.timePeriod;
        this.employeeID = parseInt(this.$route.query.employeeID) || this.employeeID;

        this.getReports();
      },

      dateFormatted: function(date) {
        return date ? this.$moment(date).format('dddd, MMMM D') : '';
      },

      getReports: function() {
        this.reportsPending = true;
        reportApi.getEmployeeHours(this.formattedQuery)
        .then((r) => {
          console.log(r)
          this.report = r.data
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.reportsPending = false
        })
      },
      reGetRecords: function() {
        this.getReports()
      },
    },
  };
</script>
